import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IdentityPageContainer } from './styles';
import { IDENTITY_PAGE } from './utils';
import { CommonButton } from '@Components';
import { CHEVRON_LEFT_ICON, DOCUMENT_ID_ICON, SHIELD_ICON } from '@Images';
import { getCountryCode, getNationality, getRfiCmsData } from '@Redux/selectors';
import { DASHBOARD_URL } from '@Utils/constants';
import { IdentityCheckProps } from './types';
import { getContentCountryCode } from '../user-flow/individual/revampedUserFlow/utils/Util';
import { getConditionalNote } from '@Utils/library';

const IdentityCheck: React.FC<IdentityCheckProps> = (props) => {
  const navigate = useNavigate();
  const identityPageCMSData = useSelector(getRfiCmsData)?.ekycRFI?.identityPage;
  const { heading, description, buttonCTA, provideDocsMsg, docList } =
    identityPageCMSData ?? IDENTITY_PAGE;
  const countryCode = useSelector(getCountryCode);
  const nationality = useSelector(getNationality);
  const { checkJumioAvailabilityAndInitiate } = props;
  const contentCountryCode = getContentCountryCode(countryCode);
  const ekycData = docList?.[contentCountryCode] ?? {};

  const navigateToJumio = () => {
    checkJumioAvailabilityAndInitiate();
  };

  const handleBackNavigation = () => {
    navigate(DASHBOARD_URL);
  };

  const getConditionalNotes = () => {
    let notesArray: String[] = [];
    notesArray.push(getConditionalNote(ekycData, countryCode, nationality) || '');
    notesArray.push(ekycData?.checkPoint?.note2 || '');
    return (
      <ul>
        {notesArray?.map((note, index) => {
          return <li key={index}>{note}</li>;
        })}
      </ul>
    );
  };

  return (
    <IdentityPageContainer>
      <div className="navigationContainer">
        <img
          className="backButton"
          onClick={handleBackNavigation}
          src={CHEVRON_LEFT_ICON}
          alt="back"
        />
      </div>

      <div className="mainContainer">
        <div className="img">
          <img src={SHIELD_ICON} alt="Shield Icon" />
        </div>
        <div className="heading">{heading}</div>
        <div className="description">{description}</div>
        <div className="docRequiredContainer">
          <div className="column1">
            <img src={DOCUMENT_ID_ICON} alt="Document Id Icon" />
          </div>
          <div className="column2">
            <div>{provideDocsMsg}</div>
            <div>{getConditionalNotes()}</div>
          </div>
        </div>
        <div className="btnWrapper">
          <CommonButton text={buttonCTA} onClick={navigateToJumio} />
        </div>
      </div>
    </IdentityPageContainer>
  );
};

export default IdentityCheck;
